import {Component, OnInit} from '@angular/core';
import {OktaService} from '@services/okta/okta.service';

@Component({
  selector: 'app-okta-callback',
  templateUrl: './okta-callback.component.html',
  styleUrls: ['./okta-callback.component.scss']
})
export class OktaCallbackComponent implements OnInit {
  error: string | null = null;

  constructor(private readonly oktaService: OktaService) {
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.oktaService.handleCallback();
    } catch (err) {
      console.error('Okta handleCallback error:', err);
      this.error = 'Authentication failed. Please try logging in again.';
    }
  }
}
